import {Component, OnInit} from '@angular/core';
import {State} from '@progress/kendo-data-query';
import {ItemGLSetup} from '@model/ItemGLSetup';
import {StoreApGLXref} from '@model/StoreApGLXref';
import {DialogType, FSInvoiceDialogService} from '~/app/core/services/fsinvoice.dialog.service';
import {HomeOffice} from '@model/HomeOffice';
import {UserService} from '~/app/core/services/user.service';
import {AuthServicesService} from 'mclane-webauth-lib';
import {Router} from '@angular/router';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {ItemSetupService} from '~/app/core/services/item-setup.service';
import {AppEnums} from '~/app/web/AppProvider/AppEnums';
import {paths} from '~/app/app-paths';
import {Chain} from '@model/Chain';
import {Division} from '@model/Division';
import {ItemDetailsComponent} from '~/app/web/setup/item-details/item-details.component';
import {ItemSetup} from '@model/ItemSetup';
import {ItemSetupDetails} from '@model/ItemSetupDetails';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';


@Component({
  selector: 'app-item-setup',
  templateUrl: './item-setup.component.html',
  styleUrls: ['./item-setup.component.scss']
})
export class ItemSetupComponent implements OnInit {
  public selectedHomeOffice: HomeOffice;

  public gridData: any = [];
  public mySelection: StoreApGLXref[] = [];
  public itemSetupList: ItemSetup[] = [];
  public itemSetupDetails: ItemSetupDetails;
  public selectedCallback = (args) => args.dataItem;
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 20
  };
  private editedRowIndex: number;
  private editedItem: ItemSetup;


  selectedChain: Chain;
  chainList: Chain[] = [];
  selectedDivision: Division;
  divisionList: Division[] = [];


  constructor(public dialogService: FSInvoiceDialogService,
              public loadingIndicator: LoadingIndicatorHelper,
              public userService: UserService,
              public authService: AuthServicesService,
              public router: Router,
              public localStorage: LocalStorageIndexedService,
              public itemSetupService: ItemSetupService) {
  }

  async ngOnInit() {
    console.log('in ngonitniet...');
    this.loadingIndicator.show();
    if (!this.userService.selectedHomeOffice) {
      if (this.localStorage.getFromSession(AppEnums.HOME_OFFICE)) {
        this.selectedHomeOffice = this.localStorage.getFromSession(AppEnums.HOME_OFFICE);
        this.chainList = await this.itemSetupService.getChainList(this.selectedHomeOffice.hoId);
        this.chainList.forEach(chain => {
          chain.display = chain.chn + ' - ' + chain.chnDesc;
        });

        this.divisionList = await this.itemSetupService.getDivisionList(this.selectedHomeOffice.hoId);
        this.divisionList.forEach(division => {
          division.display = division.divId + ' - ' + division.divName;
        });
        this.loadingIndicator.hide();
      } else {
        this.loadingIndicator.hide();
        this.dialogService.showErrorNotificationForDuration("No home office is selected.", 2000);
        await this.router.navigate([paths.home]);
      }
    } else {
      this.selectedHomeOffice = this.userService.selectedHomeOffice;
      this.chainList = await this.itemSetupService.getChainList(this.selectedHomeOffice.hoId);
      this.chainList.forEach(chain => {
        chain.display = chain.chn + ' - ' + chain.chnDesc;
      });

      this.divisionList = await this.itemSetupService.getDivisionList(this.selectedHomeOffice.hoId);
      this.divisionList.forEach(division => {
        division.display = division.divId + ' - ' + division.divName;
      });
      this.loadingIndicator.hide();
    }
    
    if (this.chainList.length === 1) {
      this.selectedChain = this.chainList[0];
      await this.chainValueChange(this.selectedChain);
    }
    if (this.divisionList.length === 1) {
      this.selectedDivision = this.divisionList[0];
      await this.divisionValueChange(this.selectedDivision);
    }
    this.loadingIndicator.hide();
  }


  /** To prevent page crash on mouseClick */
  handleEvent(event: MouseEvent) {
    if (event) {
      event.preventDefault();
      console.log(event.clientX);
    } else {
      console.log('Event object is undefined');
    }
  }

  async populateGrid() {
    if (this.selectedHomeOffice !== undefined && this.selectedChain !== undefined && this.selectedDivision !== undefined) {
      console.log('populateGrid()');
      console.log('hoId: ' + this.selectedHomeOffice.hoId);
      console.log('chn: ' + this.selectedChain.chn);
      console.log('divId: ' + this.selectedDivision.divId);
      this.loadingIndicator.show();
      this.itemSetupList = await this.itemSetupService.getItemList(this.selectedHomeOffice.hoId, this.selectedChain.chn, this.selectedDivision.divId);
      this.mySelection = [];
      this.gridData = this.itemSetupList;
      this.gridData.total = this.itemSetupList.length;
    }
    this.loadingIndicator.hide();
  }

  public onStateChange(state: State) {
    this.gridState = state;
  }

  public editHandler({sender, rowIndex, dataItem}) {
    // close the previously edited item
    this.closeEditor(sender);

    // track the most recently edited row
    // it will be used in `closeEditor` for closing the previously edited row
    this.editedRowIndex = rowIndex;

    // clone the current - `[(ngModel)]` will modify the original item
    // use this copy to revert changes
    this.editedItem = Object.assign({}, dataItem);

    // edit the row
    sender.editRow(rowIndex);
  }

  public addHandler({sender}, formInstance) {
    formInstance.reset();
    this.closeEditor(sender);
    sender.addRow(new ItemGLSetup());
  }

  public cancelHandler({sender, rowIndex}) {
    this.closeEditor(sender, rowIndex);
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    // close the editor
    grid.closeRow(rowIndex);

    // revert the data item to original state
    this.resetItem(this.editedItem);

    // reset the helpers
    this.editedRowIndex = undefined;
    this.editedItem = undefined;
  }

  resetItem(editedItem: ItemSetup) {
    if (!editedItem) {
      return;
    }

    // find orignal data item
    const originalDataItem = this.itemSetupList.find(item => item.itemNum === editedItem.itemNum);

    // revert changes
    Object.assign(originalDataItem, editedItem);

    // super.next(this.storeApGLXrefList);
  }

  public saveHandler({sender, rowIndex, dataItem, isNew}) {
    console.warn({sender, rowIndex, dataItem, isNew});
    // update the data source
    this.itemSetupService.save(dataItem).subscribe(() => {
      this.populateGrid().then(r => r);
      this.editedItem = undefined;
      this.dialogService.showSuccessNotification('Update Successful');
    });

    // close the editor, that is, revert the row back into view mode
    sender.closeRow(rowIndex);
  }


  public removeHandler({dataItem}) {
    this.dialogService.openDialog({
      type: DialogType.INFO,
      title: 'Available Exports',
      content: 'Are you sure you want to delete?',
      actions: [
        {text: 'Close', primary: false},
        {text: 'Ok', primary: true},
      ],
      width: 400
    }).then((answer) => {
      if (answer === 'Ok') {
        console.warn(dataItem);
        this.itemSetupService.delete(dataItem)
          .subscribe(() => {
            this.populateGrid().then(r => r);
            this.dialogService.showSuccessNotification('Delete Successful');
          });
      }
    });
  }


  chainValueChange(chain: Chain) {
    this.selectedChain = chain;
    this.populateGrid().then(r => r);
  }

  divisionValueChange(division: Division) {
    this.selectedDivision = division;
    this.populateGrid().then(r => r);
  }

  add() {
    this.dialogService.showInfoNotification('Add Clicked');
    const dialogRef = this.dialogService.open({
      type: DialogType.INFO,
      title: 'Add New Item',
      content: ItemDetailsComponent,
      actions: [
        {text: 'Close', primary: false},
        {text: 'Ok', primary: true}
      ],
      width: 600
    });
  }

  async goToItemDetails(dataItem) {
    this.dialogService.showInfoNotification('Item Details Clicked');
    console.log(dataItem);

    const dialogRef = this.dialogService.open({
      type: DialogType.INFO,
      title: 'Item Details',
      content: ItemDetailsComponent,
      actions: [
        {text: 'Close', primary: true}
      ],
      width: 600
    });

    console.log('chn: ' + this.selectedChain.chn);
    console.log('divId: ' + this.selectedDivision.divId);
    console.log('hoId: ' + this.selectedHomeOffice.hoId);
    console.log(' dataItem.itemNum: ' + dataItem.itemNum);


    this.itemSetupDetails = await this.itemSetupService.getItemDetails(this.selectedChain.chn, this.selectedDivision.divId, this.selectedHomeOffice.hoId, dataItem.itemNum);


    const dialogContent = dialogRef.content.instance;
    dialogContent.itemNum = this.itemSetupDetails.itemNum;
    dialogContent.chain = this.selectedChain.chn;
    dialogContent.generic = this.itemSetupDetails.gnrcItemNum;
    dialogContent.dc = this.selectedDivision.divId;
    dialogContent.itemDesc = this.itemSetupDetails.itemDesc;
    dialogContent.purchaseUom = this.itemSetupDetails.purUom;
    dialogContent.packSize = this.itemSetupDetails.pckSize;
    dialogContent.packUom = this.itemSetupDetails.purUom;
    dialogContent.maxQuantity = this.itemSetupDetails.maxQty;
    dialogContent.criticalItem = this.itemSetupDetails.criticalItem;
    dialogContent.active = this.itemSetupDetails.itemStat;
    dialogContent.restriction = this.itemSetupDetails.restrict;
    dialogContent.enforce = this.itemSetupDetails.enforceRest;
    dialogContent.binBay = this.itemSetupDetails.binbay;
    dialogContent.cubeSize = this.itemSetupDetails.cubeSize;
    dialogContent.xrefFactor = this.itemSetupDetails.xref;
    dialogContent.itemPrice = this.itemSetupDetails.itemPrice;
    dialogContent.glCode = dataItem.catCd;
    dialogContent.catchWeight = this.itemSetupDetails.itemNum;


    // navigate to the item details screen and call the APIs, with this info...
    //  this.router.navigate([paths.itemGlDetails]).then(r => r);

  }
}
